export interface CheckoutInsuranceProvider {
  name: string;
  id: string;
}

export interface CheckoutInsurancePlan {
  name: string;
  id: string;
}

export interface DateOfBirth {
  day: string;
  month: string;
  year: string;
}

export enum SexAtBirth {
  Male = 'Male',
  Female = 'Female',
}

interface CheckoutPatient {
  firstName: string;
  lastName: string;
  dateOfBirth: DateOfBirth;
  sexAssignedAtBirth: SexAtBirth | null;
  isReturningPatient?: boolean;
}

interface CheckoutInsurance {
  provider: CheckoutInsuranceProvider;
  plan: CheckoutInsurancePlan;
  memberId: string;
  groupId: string;
  isPrimaryMember: boolean | null;
  primaryMember: {
    firstName: string;
    lastName: string;
    dateOfBirth: DateOfBirth;
  };
}

export enum PreferredContactMethod {
  Phone = 'phone',
  SMS = 'sms',
}

export interface PreferredContactMethods {
  [PreferredContactMethod.Phone]?: boolean;
  [PreferredContactMethod.SMS]?: boolean;
};

interface CheckoutConfirm {
  preferredContactMethods: PreferredContactMethods;
  note: string;
}

export interface CheckoutState {
  patient: CheckoutPatient;
  insurance: CheckoutInsurance;
  confirm: CheckoutConfirm;
  timeRemaining: number | null;
};
